import { observer } from "mobx-react-lite"
import SupervisionTable from "../general/supervision-table/SupervisionTable"
import { useHistory } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { JobState } from "../../models/explainability/JobState";
import { JobStateDto } from "./JobState.dto";
import Loader from "../general/loader/Loader";
import useOnInitAsync from "../../hooks/useOnInitAsync";
import { RootStoreContext } from "../../stores/RootStoreContext";
import { JobVendorState } from "../../models/explainability/JobVendorState";
import { JobBase } from "../../models/explainability/JobBase";
import { JobVendorStateDto } from "./JobVendorState.dto";
import { JobSerachingType } from "../../models/explainability/JobSerachingType";
import { Empty, Spin } from "antd";

interface Props {
    isLoading : boolean;
 }

const ExplainabilityTable = (props: Props) => {

    const { explainabilityStore } = useContext(RootStoreContext);
    const [jobs, setJobs] = useState<JobBase[]>([]);

    const jobDtos = jobs.map(job => {
        if (explainabilityStore.SelectedJobSerachingType == JobSerachingType.JobVendorState) {
            return new JobVendorStateDto(job as JobVendorState);
        }
        return new JobStateDto(job as JobState);
    });

    // Extract unique values for categorical filters
    const getUniqueValues = (field: string) => {
        if (jobDtos.length === 0) return [];
        const values = jobDtos.map((dto: any) => dto[field]).filter(Boolean);
        return [...new Set(values)].sort();
    };

    const categoricalColumns: any[] = [];

    // Only add categorical columns if we have data
    if (jobDtos.length > 0) {
        // Add is_distributed filter for JobState view only
        if (explainabilityStore.SelectedJobSerachingType != JobSerachingType.JobVendorState) {
            categoricalColumns.push({
                column: "is_distributed",
                possibleValues: getUniqueValues("is_distributed")
            });
        }

        // Add reason_name and user_name filters for both views
        categoricalColumns.push(
            {
                column: "reason_name", 
                possibleValues: getUniqueValues("reason_name")
            },
            {
                column: "user_name",
                possibleValues: getUniqueValues("user_name")
            }
        );
    }

    useEffect(() => {
        setJobs(explainabilityStore.JobsState);
    }, [explainabilityStore.JobsState])

    if (props.isLoading) {
        return <Loader position="normal" />;
    }
    
    if (!jobDtos || jobDtos.length == 0) {
        return <Empty style={{ marginTop: "40px" }} description={`No Data Found`} />
    }



    return (
        <SupervisionTable
            dataSource={jobDtos}
            categoricalColumns={categoricalColumns}
        />
    )
}


export default observer(ExplainabilityTable)